import React from "react";
import { Route, Routes } from "react-router-dom";

import { pageNotFound } from "lib/errorHandler";

import { EditRolePage } from "./editRole";
import { RolesPage } from "./roles";

export const RolesIndex: React.FC = () => {
  return (
    <Routes>
      {pageNotFound}
      <Route index element={<RolesPage />} />
      <Route path=":id/edit/*" element={<EditRolePage />} />
    </Routes>
  );
};
